/**
 * @returns if user uses application
 */
export function isApplication() {
  return navigator.userAgent == "hmcAppUserAgent";
}

/**
 * @returns if window is smaller then 1200px.
 */
export function isMobile() {
  return window.innerWidth < 1200;
}

/**
 * @returns mobile or desktop delay integer
 */
export function backClickTimeout() {
  return isMobile() ? 600 : 1500;
}

/**
 * @returns if event is number or not
 */
export function numbersOnly(ev) {
  ev = ev ? ev : window.event;
  var charCode = ev.which ? ev.which : ev.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    ev.preventDefault();
  } else {
    return true;
  }
}

/**
 * @returns menu list
 */
export const menuList = [
  {
    path: "/dashboard",
    title: "ניהול מרפאה"
  },
  {
    path: "/dashboard/surgeries",
    title: "ניהול חדרי ניתוח/פעולות"
  },
  {
    path: "/surg-add-block",
    title: "הזמנת בלוק ניתוחים"
  },
  {
    path: "/table/appointment",
    title: "רשימת מטופלים - מרפאה"
  },
  {
    path: "/table/surgery",
    title: "רשימת מטופלים - ניתוח/פעולה"
  },
  {
    path: "/table/ivf",
    title: "תוכניות טיפול IVF",
    type: "ivf",
    requiresIVF: true
  },
  {
    path: "/table/pathology",
    title: "דוחות פתולוגיה",
    type: "pathology"
  },
  {
    path: "/table/genetics",
    title: "דוחות מעבדה גנטית",
    type: "genetics"
  },
  {
    isAccordion: true,
    title: "כלים ועזרים",
    children: [
      {
        path:
          "https://selfservice.hmc.co.il/m/mSelfService?operation=reset&init=true",
        title: "איפוס סיסמה לקמיליון",
        icon: "lock",
        target: "_blank"
      },
      {
        path: "/profile",
        title: "פרופיל רופא",
        icon: "pen"
      },
      {
        path: "/license-plate",
        title: "הוספה/החלפת רכב",
        icon: "card"
      },
      {
        path: "/cellosign-iframe/secretary-access",
        title: "פתיחת גישה למזכירת מרפאה",
        icon: "contact"
      },
      {
        action: "uploadPolicies",
        title: "טעינת קובץ ביטוח",
        icon: "upload"
      }
    ]
  },
  {
    path: "/cellosign",
    title: "טפסי הסכמה לפעולה",
    requiresIVF: true
  },
  {
    path: "/cellosign-iframe/exception-committee",
    title: "וועדת חריגים"
  },
  {
    path:
      "https://api.whatsapp.com/send/?phone=97299594809&text=שלום&type=phone_number&app_absent=0",
    title: "מוקד Fixer",
    target: "_blank"
  }
];

export const menuListMobile = [
  {
    isAccordion: true,
    title: "ניהול מרפאה",
    children: [
      {
        path: "/dashboard",
        title: "תצוגת יומן",
        icon: "date"
      },
      {
        path: "/dashboard/list",
        title: "רשימת תורים",
        icon: "list"
      }
    ]
  },
  {
    isAccordion: true,
    title: "ניתוחים",
    children: [
      {
        path: "/dashboard/surgeries",
        title: "תצוגת יומן",
        icon: "date"
      },
      {
        path: "/dashboard/surgeries/list",
        title: "רשימת ניתוחים",
        icon: "list"
      }
    ]
  },
  {
    path: "/surg-add-block",
    title: "הזמנת בלוק ניתוחים"
  },
  {
    isAccordion: true,
    title: "רשימת מטופלים",
    children: [
      {
        path: "/table/appointment",
        title: "מרפאה",
        icon: "list"
      },
      {
        path: "/table/surgery",
        title: "ניתוח/פעולה",
        icon: "list"
      },
      {
        path: "/table/ivf",
        title: "תוכניות טיפול IVF",
        icon: "list",
        requiresIVF: true
      }
    ]
  },
  {
    path: "/table/pathology",
    title: "דוחות פתולוגיה",
    type: "pathology"
  },
  {
    path: "/table/genetics",
    title: "דוחות מעבדה גנטית",
    type: "genetics"
  },
  {
    isAccordion: true,
    title: "כלים ועזרים",
    children: [
      {
        path:
          "https://selfservice.hmc.co.il/m/mSelfService?operation=reset&init=true",
        title: "איפוס סיסמה לקמיליון",
        icon: "lock",
        target: "_blank"
      },
      {
        path: "/profile",
        title: "פרופיל רופא",
        icon: "pen"
      },
      {
        path: "/license-plate",
        title: "הוספה/החלפת רכב",
        icon: "card"
      },
      {
        path: "/cellosign-iframe/secretary-access",
        title: "פתיחת גישה למזכירת מרפאה",
        icon: "contact"
      },
      {
        action: "uploadPolicies",
        title: "טעינת קובץ ביטוח",
        icon: "upload"
      }
    ]
  },
  {
    path: "/cellosign",
    title: "טפסי הסכמה לפעולה",
    requiresIVF: true
  },
  {
    path: "/cellosign-iframe/exception-committee",
    title: "וועדת חריגים"
  },
  {
    path:
      "https://api.whatsapp.com/send/?phone=97299594809&text=שלום&type=phone_number&app_absent=0",
    title: "מוקד Fixer",
    target: "_blank"
  }
];

export function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = error => reject(error);
  });
}

export async function uploadDocuments(
  files,
  appointmentId,
  type = "medicaldocuments-patient",
  isSurgery = false
) {
  const ids = [];
  for (let i = 0; i < files.length; i++) {
    if (files[i] instanceof File) {
      const base64 = await convertToBase64(files[i]);
      try {
        const res = await this.$API.uploadFile(
          appointmentId,
          "new",
          null,
          files[i].name,
          base64,
          isSurgery,
          type
        );
        if (res?.status === "ok" && res?.errordesc?.document_id) {
          ids.push(res.errordesc.document_id);
        }
      } catch (error) {
        if (error.errordesc) return { error: error.errordesc };
        return { error: "התרחשה שגיאה בהעלאת הקובץ" };
      }
    }
  }
  return ids;
}
